export const isUnitCurrency = (unit: string): boolean => ['€', '$', '£', '¥'].includes(unit);
